import { render, staticRenderFns } from "./FabricRequirementForm.vue?vue&type=template&id=cb1b2a8a&scoped=true"
import script from "./FabricRequirementForm.vue?vue&type=script&lang=js"
export * from "./FabricRequirementForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb1b2a8a",
  null
  
)

export default component.exports